import { render } from "./Dashboard.vue?vue&type=template&id=b08f3942&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-b08f3942"

export default script